import React, { useState, useEffect } from "react";
import MainContainer from "../../layout/MainContainer";
import { Button, Card, Grid, TextField, Typography } from "@mui/material";
// import EditText from "../../components/EditText";
import PhoneInput from "react-phone-input-2";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import "react-phone-input-2/lib/bootstrap.css";
import {
  useGetCmsMutation,
  useLazyAddContactQuery,
  useLazyPostAddPrivacyQuery,
  useLazyPostAddTermsQuery,
  useLazyPostAddCookiesQuery,
  useLazyPostAddAboutUsQuery,
  useLazyPostAddDataDeletionQuery,
  useLazyPostAddAgreementQuery,
} from "../../services/cms";
// import { useAddFaqMutation, useGetAllFaqQuery } from "../../services/manageCms";
import {
  errorToast,
  getFromStorage,
  STORAGE_KEYS,
  successToast,
} from "../../helpers";
import * as Yup from "yup";
import { useFormik } from "formik";

import EditText from "../../components/EditText";
import useTranslation from "../../hooks/Translation";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
interface ContactSupport {
  email?: string;
  phone_no?: string;
  // Add other properties if needed
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCms = () => {
  const t = useTranslation();
  const [privacyPolicy, setPrivacyPolicy] = useState<string>("");
  const [agreement, setAgreement] = useState<string>("");
  const [cookiesPolicy, setCookiesPolicy] = useState<string>("");
  const [terms_condition, setterms_condition] = useState<string>("");
  const [aboutUs, setAbout] = useState<string>("");
  const [dataDeletion, setDataDeletionPolicy] = useState<string>("");
  const [cmsSupportApi] = useGetCmsMutation();
  const [addAboutusApi] = useLazyPostAddAboutUsQuery();
  const [addAgreementApi] = useLazyPostAddAgreementQuery();
  const [dataDeletionApi] = useLazyPostAddDataDeletionQuery();
  const [terms_conditionApi] = useLazyPostAddCookiesQuery();
  const [cookies_policyApi] = useLazyPostAddCookiesQuery();

  const [inputdata, setInputdata] = useState<any>();
  const [dialCode, setPhoneCode] = useState("+971");
  const [ContactSupport, setContactSupport] = useState<ContactSupport>({});

  const [error1, setError1] = useState<boolean>(false);
  const [error2, setError2] = useState<boolean>(false);
  const [error3, setError3] = useState<boolean>(false);
  const [error4, setError4] = useState<boolean>(false);
  const [error5, setError5] = useState<boolean>(false);
  const [error7, setError7] = useState<boolean>(false);
  const [value, setValue] = useState(0);
  const [CountryCode, setCountryCode] = useState<string>("+971");

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [updateCms, { isLoading }] = useLazyAddContactQuery();
  const [updatePrivacy] = useLazyPostAddPrivacyQuery();
  const [fetchterms_conditionApi] = useLazyPostAddTermsQuery();
  const [cmsData, setCmsData] = useState<any>(null);
  const getLang = getFromStorage(STORAGE_KEYS.language);

  const formik = useFormik({
    enableReinitialize: true, // Allow reinitialization of values when inputdata changes
    initialValues: {
      email: inputdata?.email || "",
      phone_no: inputdata?.phone_no || "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      phone_no: Yup.string()
        // .required("Phone number is required")
        .matches(/^[0-9]{9,15}$/, "Enter a valid phone number!"),
    }),
    onSubmit: async (values) => {
      try {
        const body = {
          email: values.email,
          phone_no: values.phone_no,
          country_code: dialCode,
        };
        const response = await updateCms({ body }).unwrap();
        if (response?.status === 200) successToast(t.main.cmsUpdated);
      } catch (error: any) {
        errorToast(error?.message || "Failed to update Contact Support.");
      }
    },
  });

  const formik2 = useFormik({
    initialValues: {
      privacyPolicy: privacyPolicy || "",
    },
    validationSchema: Yup.object({
      privacyPolicy: Yup.string().required(t.error.required),
    }),
    onSubmit: async (values) => {
      formik2.setSubmitting(true);
      if (values?.privacyPolicy?.length < 9) {
        setError1(true);
        return;
      }
      if (values?.privacyPolicy?.length >= 9) {
        setError1(false);
      }

      try {
        let body = { privacy_policy: values.privacyPolicy || "" };
        const response = await updatePrivacy({ body }).unwrap();
        if (response?.status === 200) fetchContactSupport();
      } catch (error) {
        errorToast("Failed to update Privacy Policy");
      } finally {
        formik2.setSubmitting(false);
      }
    },
  });
  const formik3 = useFormik({
    enableReinitialize: true,
    initialValues: {
      terms_condition: terms_condition || "",
    },
    validationSchema: Yup.object({
      terms_condition: Yup.string().required(t.error.required),
    }),
    onSubmit: async (values) => {
      formik3.setSubmitting(true);
      if (values?.terms_condition?.length < 9) {
        setError2(true);
        return;
      }

      try {
        let body = { terms_condition: values.terms_condition || "" };
        const response = await fetchterms_conditionApi({ body }).unwrap();
        if (response?.status === 200) fetchContactSupport();
      } catch (error: any) {
        errorToast(error?.message || "");
      } finally {
        formik2.setSubmitting(false);
      }
    },
  });
  const formik4 = useFormik({
    enableReinitialize: true,
    initialValues: {
      cookies_policy: cookiesPolicy || "",
    },
    validationSchema: Yup.object({
      cookies_policy: Yup.string().required(t.error.required),
    }),
    onSubmit: async (values) => {
      formik4.setSubmitting(true);
      if (values?.cookies_policy?.length < 9) {
        setError3(true);
        return;
      }
      // if (cookiesPolicy == "<p></p>") {
      //   setError3(true);
      //   return;
      // }
      try {
        const body = { cookies_policy: values.cookies_policy || "" };
        const response = await cookies_policyApi({ body }).unwrap();
        if (response?.status === 200) {
          fetchContactSupport(); // Refresh data after successful update
        }
      } catch (error: any) {
        console.error("Error during API call:", error); // Log error
        errorToast(error?.message || "Failed to update Cookies Policy");
      } finally {
        formik4.setSubmitting(false);
      }
    },
  });
  const formik5 = useFormik({
    enableReinitialize: true,
    initialValues: {
      about_us: aboutUs || "",
    },
    validationSchema: Yup.object({
      about_us: Yup.string().required(t.error.required),
    }),
    onSubmit: async (values) => {
      formik5.setSubmitting(true);
      // if (aboutUs == "<p></p>") {
      //   setError4(true);
      //   return;
      // }
      if (values?.about_us?.length < 9) {
        setError4(true);
        return;
      }
      try {
        const body = { about_us: values.about_us || "" };
        const response = await addAboutusApi({ body }).unwrap();
        if (response?.status === 200) {
          fetchContactSupport();
        }
      } catch (error: any) {
        console.error("Error during API call:", error);
        errorToast(error?.message || "Failed to update Cookies Policy");
      } finally {
        formik4.setSubmitting(false);
      }
    },
  });
  const formik6 = useFormik({
    enableReinitialize: true,
    initialValues: {
      data_deletion_policy: dataDeletion || "",
    },
    validationSchema: Yup.object({
      data_deletion_policy: Yup.string().required(t.error.required),
    }),
    onSubmit: async (values) => {
      formik5.setSubmitting(true);
      try {
        const body = {
          data_deletion_policy: values.data_deletion_policy || "",
        };
        // if (dataDeletion == "<p></p>") {
        //   setError5(true);
        //   return;
        // }
        if (values?.data_deletion_policy?.length < 9) {
          setError5(true);
          return;
        }
        const response = await dataDeletionApi({ body }).unwrap();
        if (response?.status === 200) {
          fetchContactSupport();
        }
      } catch (error: any) {
        console.error("Error during API call:", error);
        errorToast(error?.message || "Failed to update data deletion Policy");
      } finally {
        formik4.setSubmitting(false);
      }
    },
  });
  const formik7 = useFormik({
    enableReinitialize: true,
    initialValues: {
      agreement: agreement || "",
    },
    validationSchema: Yup.object({
      agreement: Yup.string().required(t.error.required),
    }),
    onSubmit: async (values) => {
      formik7.setSubmitting(true);

      if (values?.agreement?.length < 9) {
        setError7(true);
        return;
      } else setError7(false);
      try {
        const body = { agreement: values.agreement || "" };
        const response = await addAgreementApi({ body }).unwrap();

        if (response?.status === 200) {
          fetchContactSupport();
        }
      } catch (error: any) {
        console.error("Error during API call:", error);
        errorToast(error?.message || "Failed to update Agreement");
      } finally {
        formik7.setSubmitting(false);
      }
    },
  });
  // const handleChangePhone = (phone: any, country: any) => {
  //   formik.setFieldValue("  phone_no", phone?.replace(country?.dialCode, ""));
  //   setPhoneCode(
  //     country?.dialCode.includes("+") ? "" : "+" + country?.dialCode
  //   );
  // };
  const handleChangePhone = (phone: string, country: any) => {
    formik.setFieldValue("phone_no", phone.replace(country?.dialCode, ""));
    setPhoneCode(
      country?.dialCode.includes("+")
        ? country.dialCode
        : "+" + country.dialCode
    );
  };

  const fetchContactSupport = async () => {
    try {
      const response = await cmsSupportApi({}).unwrap();
      if (response?.status === 200) {
        const cmsData = response?.data;
        // Set the CMS data into the state
        setPrivacyPolicy(cmsData?.privacy_policy?.privacy_policy || "");
        setAgreement(cmsData?.agreement?.agreement || "");
        setCookiesPolicy(cmsData?.cookies_policy?.cookies_policy || "");
        setterms_condition(cmsData?.terms_condition?.terms_condition || "");
        setAbout(cmsData?.about_us?.about_us || "");
        setInputdata(cmsData?.contact_support || "");
        setPhoneCode(cmsData?.contact_support?.country_code || dialCode);
        setDataDeletionPolicy(
          cmsData?.data_deletion_policy?.data_deletion_policy || ""
        );
        // Set any other data if needed
        // setDataDeletionPolicy(cmsData?.data_deletion_policy?.data_deletion_policy || "");
      }
    } catch (e: any) {
      errorToast(e?.message || "Failed to fetch CMS data");
    }
  };

  useEffect(() => {
    fetchContactSupport();
  }, []);
  return (
    <div>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.sideBar.manageCms}</h1>
          {/* <Loader isLoad={isLoading || load} /> */}
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label={t.main.contactSupport} {...a11yProps(0)} />
              <Tab label={t.main.privacyPolicy} {...a11yProps(1)} />
              <Tab label={t.main.agreement} {...a11yProps(2)} />
              <Tab label={t.main.terms} {...a11yProps(3)} />
              <Tab label={t.main.cookiesPolicy} {...a11yProps(4)} />
              <Tab label={t.main.about} {...a11yProps(5)} />
              <Tab label={t.main.dataDeletion} {...a11yProps(6)} />
            </Tabs>
            <CustomTabPanel value={value} index={0}>
              <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {t.main.email}
                    </Typography>
                    <TextField
                      className="text_field"
                      hiddenLabel
                      type={"email"}
                      name="email"
                      variant="outlined"
                      fullWidth
                      placeholder="Email"
                      value={formik.values.email}
                      onChange={(event) =>
                        formik.setFieldValue("email", event.target.value)
                      }
                      onBlur={formik.handleBlur}
                      helperText={
                        formik.touched.email && formik.errors.email
                          ? String(formik.errors.email)
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {t.main.phoneNumber}
                    </Typography>
                    <PhoneInput
                      value={dialCode + formik.values.phone_no}
                      country={"ae"}
                      placeholder="0 (000) 000-000"
                      enableSearch={true}
                      inputStyle={{
                        width: "100%",
                        direction: getLang === "ar" ? "rtl" : "ltr",
                        paddingRight: getLang === "ar" ? "80px" : "0px",
                      }}
                      onChange={(phone, country) =>
                        handleChangePhone(phone, country)
                      }
                      buttonStyle={{
                        marginRight: getLang === "ar" ? "40px" : "0px",
                      }}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.phone_no &&
                      typeof formik.errors.phone_no === "string" ? (
                      <h6 className="err_msg">{formik.errors.phone_no}</h6>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                    onClick={() => { }}
                  >
                    {t.main.save}
                  </Button>
                </div>
              </form>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <form onSubmit={formik2.handleSubmit}>
                <EditText
                  content={privacyPolicy}
                  setContent={(value) => {
                    setPrivacyPolicy(value);
                    formik2.setFieldValue("privacyPolicy", value);
                  }}
                />
                {error1 == true ? (
                  <h6 className="err_msg">{t.error.required}</h6>
                ) : (
                  ""
                )}
                {formik2.touched.privacyPolicy &&
                  formik2.errors.privacyPolicy && (
                    <h6 className="err_msg">{formik2.errors.privacyPolicy}</h6>
                  )}
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                    disabled={formik2.isSubmitting}
                  >
                    {t.main.save}
                  </Button>
                </div>
              </form>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <form onSubmit={formik7.handleSubmit}>
                <EditText
                  content={agreement}
                  setContent={(value) => {
                    setAgreement(value);
                    formik7.setFieldValue("agreement", value);
                  }}
                />
                {error7 ? <h6 className="err_msg">{t.error.required}</h6> : ""}
                {formik7.touched.agreement && formik7.errors.agreement && (
                  <h6 className="err_msg">{formik7.errors.agreement}</h6>
                )}
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                    disabled={formik7.isSubmitting}
                  >
                    {t.main.save}
                  </Button>
                </div>
              </form>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <form onSubmit={formik3.handleSubmit}>
                <EditText
                  content={terms_condition}
                  setContent={setterms_condition}
                />
                {error2 ? <h6 className="err_msg">{t.error.required}</h6> : ""}
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    {t.main.save}
                  </Button>
                </div>
              </form>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={4}>
              <form onSubmit={formik4.handleSubmit}>
                <EditText
                  content={cookiesPolicy}
                  setContent={setCookiesPolicy}
                />
                {error3 ? <h6 className="err_msg">{t.error.required}</h6> : ""}
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    {t.main.save}
                  </Button>
                </div>
              </form>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={5}>
              <form onSubmit={formik5.handleSubmit}>
                <EditText content={aboutUs} setContent={setAbout} />
                {error4 ? <h6 className="err_msg">{t.error.required}</h6> : ""}
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    {t.main.save}
                  </Button>
                </div>
              </form>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={6}>
              <form onSubmit={formik6.handleSubmit}>
                <EditText
                  content={dataDeletion}
                  setContent={setDataDeletionPolicy}
                />
                {error5 ? <h6 className="err_msg">{t.error.required}</h6> : ""}
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    {t.main.save}
                  </Button>
                </div>
              </form>
            </CustomTabPanel>
          </Box>
        </Card>
      </div>
    </div>
  );
};

export default ManageCms;
